import { ClinicianInfo } from '@cartwheel/components'

interface ClinicianHeaderProps {
  clinician: {
    name: string
    avatar_url?: string | null
    pod?: string | null
    clinical_manager?: string | null
  }
}

export function ClinicianHeader({ clinician }: ClinicianHeaderProps) {
  return (
    <div className="pb-4 border-b border-gray-stroke">
      <ClinicianInfo clinician={clinician} />
    </div>
  )
}
